import React from 'react'

import { useLastActiveMediaTrayCard } from '../../../../firebase/hooks/useTray'
import type { FeedMedia, Mix } from '../../../../firebase/model/mix'
import type { DeepReadonly } from '../../../../firebase/typeUtils'
import { debug } from '../../../../global/debug'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { FloorTrayImage } from '../../../../Stage/floor/FloorFeed/FloorTrayFeed/FloorTrayImage/FloorTrayImage'
import { posToStyle } from '../../../../Stage/layouts'
import {
  useHeadlessParticipant,
  useParticipant,
} from '../../../../webrtc/webRTCRoom'

import './MixPreview.scss'

interface LayoutPreviewProps {
  mix: DeepReadonly<Mix>
}
const MixPreview = ({ mix }: LayoutPreviewProps) => {
  return (
    <div className="mix-preview">
      <div>
        {mix.feeds.map((f, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={idx} style={posToStyle(f.position)}>
            {debug.participantStripFullMixPreview && f.media && (
              <Track track={f.media} />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

const Track = ({ track }: { track: DeepReadonly<FeedMedia> }) => {
  if (track.type === 'tray') {
    return <TrayTrack />
  }
  return <ParticipantTrack type={track.type} participantId={track.id} />
}

const ParticipantTrack = ({
  type,
  participantId,
}: {
  type: 'camera' | 'screen' | 'mobile'
  participantId: number
}) => {
  const participant = useParticipant(participantId)

  if (!participant) return null

  const mediaTrack = participant.tracks[type]

  if (!mediaTrack) return null

  return <VideoTrack track={mediaTrack} objectFit="cover" />
}

const TrayTrack = () => {
  const lastActiveMediaCard = useLastActiveMediaTrayCard()

  const headlessParticipant = useHeadlessParticipant()

  return (
    <div className="tray-track">
      {lastActiveMediaCard?.type === 'image' ? (
        <FloorTrayImage trayCard={lastActiveMediaCard} />
      ) : (
        <>
          {lastActiveMediaCard?.type === 'video' &&
            headlessParticipant?.tracks.screen && (
              <VideoTrack
                track={headlessParticipant.tracks.screen}
                objectFit="contain"
              />
            )}
        </>
      )}
    </div>
  )
}

export { MixPreview }
